import React from "react";
import PropTypes from "prop-types";

// removed exportAsValue as a prop because it was not being used (EBW)
const NumberCell = ({ value }) => (
  <div style={{ width: "100%", textAlign: "right" }}>{value}</div>
);

NumberCell.propTypes = {
  value: PropTypes.string
};

export default NumberCell;
